import { Children, useLayoutEffect, useRef, useState } from "react";
import MenuHeader from "./MenuHeader";

type MenuHeaderProps = {
  title: string;
  children?: React.ReactNode;
};

const MenuHeaderWrapper = (props: MenuHeaderProps) => {
  const { title, children } = props;
  const childrenContainerRef = useRef<HTMLDivElement | null>(null);
  const [showHeader, setShowHeader] = useState(false);

  useLayoutEffect(() => {
    const container = childrenContainerRef.current;
    setShowHeader(Boolean(container?.firstElementChild));
  }, [children]);

  const hasPotentialChildren = Children.toArray(children).length > 0;

  if (!hasPotentialChildren) return null;

  return (
    <>
      {showHeader ? <MenuHeader title={title} /> : null}
      <div ref={childrenContainerRef} style={{ display: "contents" }}>
        {children}
      </div>
    </>
  );
};

export default MenuHeaderWrapper;
